import { ClientLoaderFunctionArgs, useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { Route } from "@route-types/Section/+types/SectionPage";
import SectionPageContent from "@routes/Section/SectionPageContent";
import { fetchSectionPageData } from "@routes/Section/server/SectionPage.server";
import { SectionPageContext } from "@routes/Section/utils/types";
import { fetchContext, ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

/** This is the main entry point component for /section route. */
const SectionPage = (): React.ReactElement => {
  const context = useLoaderData<SectionPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return <SectionPageContent {...context.payload.data} />;
};

export default SectionPage;

export const loader = async ({ request }: Route.LoaderArgs) => {
  const url = new URL(request.url, `http://localhost`);
  const path = url.pathname;

  return await fetchSectionPageData(path);
};

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as SectionPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const result = (await fetchContext(args)) as { context?: SectionPageContext };

  if (!result.context) return await args.serverLoader();

  return result.context;
};
